import {configureStore} from '@reduxjs/toolkit';
import userContextReducer from './userContextSlice.js';

export const store = configureStore({
  reducer: {
    userContext: userContextReducer
  },
});
